<template>
  <div>
    <div class="content-block">
      <div class="asd-form-section heading-section">
        <h1>
          Nový uživatel
        </h1>
      </div>
      <div class="asd-form-section">
        <div class="section-title">
          <h5>
            <i class="fas fa-user-edit"></i>
            Údaje
          </h5>
          <div class="section-title-controls">
            <button class="asd-btn-confirm" @click="randomizePassword">
              <i class="fas fa-dice"></i>
              Vygenerovat náhodné heslo
            </button>
          </div>
        </div>
        <div class="asd-form">
          <div class="grid">
            <div>
              <label>Uživatelské jméno (email)</label>
              <input v-model="userData.email"
                     type="text"
                     class="asd-input"
              />
            </div>
            <div>
              <label>Jméno</label>
              <input v-model="userData.name"
                     type="text"
                     class="asd-input"
              />
            </div>
            <div>
              <label>Příjmení</label>
              <input v-model="userData.surname"
                     type="text"
                     class="asd-input"
              />
            </div>
            <div>
              <label>Heslo</label>
              <input v-model="userData.password"
                     type="text"
                     class="asd-input"
              />
              <Password v-model="userData.password" :strengthMeterOnly="true"></Password>
            </div>
            <div>
              <label>Přiřaďit firmu podle zvacího kódu</label>
              <input v-model="inviteCode"
                     type="text"
                     class="asd-input"
              />
            </div>
          </div>
        </div>
      </div>
      <FormControls>
        <button class="asd-btn-confirm" @click="create">
          Vytvořit
        </button>
      </FormControls>
    </div>
  </div>
</template>

<script>
import { head, get } from 'lodash'
import FormControls from 'CORE/components/form/controls'
import Password from 'vue-password-strength-meter'
import passwordGenerator from 'CORE/utils/password-generator'
import EventBus from 'CORE/bus'

export default {
    name: 'UsersAdministrationForm',
    components: {
        FormControls,
        Password,
    },
    props: {

    },
    data() {
        return {
            userData: {
                email: '',
                password: 'heslo123',
                name: '',
                surname: '',
                settings: {},
            },
            inviteCode: '1234',
        }
    },
    computed: {
    },
    methods: {
        async create() {
            try {
                const inviteCompanyId = get(head(await this.$store.dispatch('verifyInviteCode', this.inviteCode)), 'id')
                EventBus.$emit('FLASH_OK', { message: `Zvací kód ${this.inviteCode} ověřen.` })

                this.$set(this.userData, 'company', { 'id': inviteCompanyId })

                const newUser = await this.$store.dispatch('createUser', this.userData)
                EventBus.$emit('FLASH_OK', { message: `Uživatel vytvořen.` })

                await this.$store.dispatch('usersLoad')

                EventBus.$emit('FLASH_INFO', { message: `Nezapomeňte přiřadit uživatele do nějaké skupiny. Defaultně se uživatel nemůže přihlásit.` })

                this.$router.push({ name: 'usersDetail', params: { id: get(newUser, 'id') } })
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
        randomizePassword() {
            this.userData.password = passwordGenerator()
        },
    },
}
</script>

<style scoped lang="scss">
@media (min-width: 0px) and (max-width: 767px) {
  .grid {
    display: grid;
    grid-auto-rows: minmax(60px, auto);
    grid-template-columns: 1fr;
    grid-gap: 5px;
  }
}

@media (min-width: 768px) and (max-width: 1199px) {
  .grid {
    display: grid;
    grid-auto-rows: minmax(60px, auto);
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
  }
}

@media (min-width: 1200px) {
  .grid {
    display: grid;
    grid-auto-rows: minmax(60px, auto);
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 30px;
  }
}
</style>

